import { can } from "modules/settings/accessRoles";
import {
  Button as MuiButton,
  Card,
  CardContent,
  Checkbox,
  Divider as MuiDivider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import TableContainer from "@mui/material/TableContainer";
import EditIcon from "@mui/icons-material/Edit";
import Skeleton from "@mui/material/Skeleton";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import style from "../../property/components/styling/style";
import PropertyGLCodeForm from "./Form";

const Divider = styled(MuiDivider)(spacing);
const Button = styled(MuiButton)(spacing);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function GLCodeDetailCard(props) {
  const useStyles = style;
  const classes = useStyles();
  const [display, setDisplay] = React.useState(false);

  // Support external control of modal via props
  const isModalOpen = props.externalOpen !== undefined ? props.externalOpen : display;

  const toggleDisplay = () => {
    const shouldDisplay = !display;
    setDisplay(shouldDisplay);
    // If external control is provided, call the callback
    if (props.onExternalClose) {
      props.onExternalClose();
    }
  };

  const handleClose = () => {
    if (props.externalOpen !== undefined && props.onExternalClose) {
      // External control - use callback
      props.onExternalClose();
    } else {
      // Internal control - use state
      toggleDisplay();
    }
  };

  function formatCurrency(s) {
    return "$" + s;
  }

  // If hideCard is true, only render the dialog (for external control)
  if (props.hideCard) {
    return (
      <Dialog
        open={isModalOpen}
        TransitionComponent={Transition}
        fullWidth={"xs"}
        maxWidth={"xs"}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {props.propertyGLCode.data.propertyGLCode ? (
          <DialogTitle id="alert-dialog-slide-title">
            Accounting ID 
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-slide-title">
            Loading Account ID.....{" "}
          </DialogTitle>
        )}
        <DialogContent>
          {props.propertyGLCode.data.propertyGLCode && (
            <PropertyGLCodeForm
              onUpdate={handleClose}
              onCancel={handleClose}
            />
          )}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Card mb={6}>
      <CardContent xs={12}>
        <Grid container>
          <Grid item xs={9} sm={9} md={9} lg={9}>
            <Typography variant="h6" gutterBottom>
              Accounting ID
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            sm={3}
            md={3}
            lg={3}
            className={classes.rightSideHeaderSubMenuToolBar}
          >
            {can(props.user.details, "accountingTools") ? ( <Button onClick={toggleDisplay}>
              <EditIcon
                fontSize="medium"
                className={classes.SubMenuToolBarIcon}
              />
            </Button>) : (
              <p></p>
            )}
           
            <Dialog
              open={isModalOpen}
              TransitionComponent={Transition}
              fullWidth={"lg"}
              maxWidth={"lg"}
              keepMounted
              onClose={handleClose}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              {props.propertyGLCode.data.propertyGLCode ? (
                <DialogTitle id="alert-dialog-slide-title">
                  Accounting ID 
                </DialogTitle>
              ) : (
                <DialogTitle id="alert-dialog-slide-title">
                  Loading Account ID.....{" "}
                </DialogTitle>
              )}
              <DialogContent>
                {props.propertyGLCode.data.propertyGLCode && (
                  <PropertyGLCodeForm
                    onUpdate={handleClose}
                    onCancel={handleClose}

                  />
                )}
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>
        <Divider className="mb-2 mt-2" my={1} />
        {!props.propertyGLCode.data.propertyGLCode ? (
          <>
            <Skeleton
              variant="rect"
              height="40px"
              style={{
                backgroundColor: `#bdbfbe`,
                padding: 6,
                margin: 6,
                marginBottom: 3,
              }}
            />
            </>
        ) : (
          <Grid
            container
            spacing={2}
            className={classes.PropertyInfoGrid}
          >
            <Grid item xs={12} lg={12} spacing={2}>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                  < TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="body1">  Accounting ID </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {props.propertyGLCode.data.propertyGLCode
                            .glCode || ""}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}

GLCodeDetailCard.propTypes = {
  apl: PropTypes.object.isRequired,
  propertyGLCode: PropTypes.object.isRequired,
  externalOpen: PropTypes.bool,
  onExternalClose: PropTypes.func,
  hideCard: PropTypes.bool, // Option to hide the card and only show modal
};

function GLCodeDetailCardState(state) {
  return {
    apl: state.apl,
    user: state.user,
    propertyGLCode: state.propertyGLCode
  };
}

export default connect(GLCodeDetailCardState, {})(GLCodeDetailCard);
